import React, { useCallback } from 'react';

import { MenuItem, TableCell, TableRow, TextField } from '@mui/material';

import type { SeasonLabel, TravelMonth } from './types';

interface Props {
  month: TravelMonth;
  onChange: (monthKey: string, season: SeasonLabel | null) => void;
  percentSurcharged: number | null;
  season: SeasonLabel | undefined;
}

export default function SurchargeMonthSeasonRow({ month, onChange, percentSurcharged, season }: Props) {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      onChange(month.key, value === '' ? null : (value as SeasonLabel));
    },
    [month.key, onChange],
  );

  return (
    <TableRow>
      <TableCell sx={{ whiteSpace: 'nowrap' }}>{month.label}</TableCell>
      <TableCell>
        <TextField onChange={handleChange} select size="small" sx={{ width: 160 }} value={season ?? ''}>
          <MenuItem value="">None</MenuItem>
          <MenuItem value="high">High</MenuItem>
          <MenuItem value="shoulder">Shoulder</MenuItem>
        </TextField>
      </TableCell>
      <TableCell align="right">
        {percentSurcharged == null ? '-' : `${(percentSurcharged * 100).toFixed(0)}%`}
      </TableCell>
    </TableRow>
  );
}
